/**
 * The Rickey wordmark: "rickey" set in Gloock, with the pour underline beneath
 * it.
 *
 * Three rules from the brand kit, all of them load-bearing:
 *
 *   The wordmark is always lowercase. Never re-lettered in Caveat, never set
 *   in caps.
 *
 *   The underline is drawn at 100% of the word's width and positioned
 *   absolutely, so it never inflates the box it sits in. That is why the SVG
 *   is `preserveAspectRatio="none"` and pinned left-to-right rather than being
 *   a fixed-width graphic.
 *
 *   Clear space is one lowercase r on all sides — roughly 0.42em at this
 *   optical size, which is what the wrapper's padding reserves.
 *
 * It is live text rather than an image, so it stays crisp at any size and can
 * be selected and read. Gloock is self-hosted, so there is no flash of a
 * fallback serif beyond the usual font-display window.
 */
import styles from './Logo.module.css';

interface LogoProps {
  /** Font size of the wordmark, in px. */
  size?: number;
  /**
   * Accessible name. Omit it inside a link that already says "rickey", so a
   * screen reader announces the name once rather than twice.
   */
  title?: string;
}

export function Logo({ size = 30, title }: LogoProps) {
  return (
    <span
      className={styles.mark}
      style={{ fontSize: size }}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      <span className={styles.word} aria-hidden={title ? true : undefined}>
        rickey
      </span>

      {/* The pour. One accent, one job — this is one of the three places blush
          is allowed. */}
      <svg
        className={styles.pour}
        viewBox="0 0 120 12"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M2,7 Q31,2 61,6 Q91,10 118,4"
          fill="none"
          stroke="var(--blush)"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
